import { ERole } from '@dlap-ui/core';
import type { PortalConfig } from '@dlap-ui/shared-forms/shell/portal-shell/portal-shell';
import { BANK_DASHBOARD_PAGES } from './dashboard-pages.config';

export const BANK_PORTAL_CONFIG: PortalConfig = {
  appTitle: 'Ebanking',
  logoSrc: '/bank-logo.png',
  searchPlaceholder: 'Search applications...',
  defaultRedirect: '/overview/applications',
  rolePermissions: [
    {
      role: ERole.SECOND_BANK_USER,
      permissions: ['overview', 'applications', 'fees', 'wallet', 'tickets', 'profile'],
    },
    {
      role: ERole.ASSOCIATION_ADMIN,
      permissions: [
        'overview',
        'applications',
        'fees',
        'wallet',
        'tickets',
        'profile',
        'memberships/members',
      ],
    },
    {
      role: ERole.FIRST_BANK_USER,
      permissions: [
        'overview',
        'applications',
        'drafts',
        'archived',
        'fees',
        'wallet',
        'tickets',
        'profile',
      ],
    },
    {
      role: ERole.BANK_ADMIN,
      permissions: [
        'overview',
        'applications',
        'fees',
        'wallet',
        'tickets',
        'users',
        'profile',
        'memberships/members',
      ],
    },
  ],
  dashboardPages: BANK_DASHBOARD_PAGES,
  newApplicationServiceKeys: ['bond-registration', 'bond-cancellation', 'note-of-hand'],
  resolveApplicationNavigation: (service) => {
    if (
      service.value === 'bond-registration' ||
      service.value === 'bond-cancellation' ||
      service.value === 'note-of-hand'
    ) {
      return {
        commands: ['/overview/apply'],
        queryParams: { service: service.value },
        successMessage: `Starting a new ${service.name} application.`,
      };
    }

    return {
      commands: ['/overview/applications'],
      successMessage: 'New application submission for Bank is not yet available.',
    };
  },
};
